const SemVerGte = require('semver/functions/gte')

angular
  .module('surfsightApp.controllers')
  .controller('RecordingTimelineControllerDeprecated', [
    '$rootScope',
    '$scope',
    '$timeout',
    '$interval',
    '$filter',
    '$http',
    '$q',
    '$mdToast',
    '$mdDialog',
    '$mdColors',
    '$localStorage',
    '$state',
    'edgeFactory',
    function (
      $rootScope,
      $scope,
      $timeout,
      $interval,
      $filter,
      $http,
      $q,
      $mdToast,
      $mdDialog,
      $mdColors,
      $localStorage,
      $state,
      edgeFactory
    ) {
      const updateCurrentDeviceSemanticVersion = async () => {
        const semanticVersion = await $rootScope.getDeviceSematicVersion(
          $scope.edge.uri
        )
        $scope.edge.semanticVersion = semanticVersion
        const canPlaySelectedQualityRecording = SemVerGte(
          $scope.edge.semanticVersion,
          window.CAN_PLAY_SELECTED_QUALITY_RECORDING_STREAM_VERSION
        )
        $scope.edge.canPlaySelectedQualityRecording = canPlaySelectedQualityRecording
        $scope.selectedInput.canPlaySelectedQualityRecording = canPlaySelectedQualityRecording
        $scope.selectedInput.recordingStreamQuality = $scope.edge
          .canPlaySelectedQualityRecording
          ? window.LOW_QUALITY_RECORDING_STREAM
          : window.HIGH_QUALITY_RECORDING_STREAM
      }
      const deviceId = parseInt($scope.deviceId)
      let edge = edgeFactory.list.find(e => e.id === deviceId)
      let serialNumber = null
      $scope.defaultTimezoneOffset = moment().utcOffset()
      $scope.TimezonesList = window.TimezonesList
      $scope.selectedInput = {
        date: moment(),
        timezoneOffset: $scope.defaultTimezoneOffset,
        cameraId: window.frontCameraId,
        sliderValue: 0,
        currentSliderValue: 0,
        dataLoading: false,
        canPlaySelectedQualityRecording: true,
        recordingStreamQuality: window.LOW_QUALITY_RECORDING_STREAM
      }
      $scope.recordingData = {}
      $scope.playerState = {
        hasRecording: false,
        playState: false,
        showPlayer: false,
        recordingStartTime: false
      }
      $scope.maxSliderInput = 24 * 60 - 1
      $scope.higlightDates = []
      $scope.timelineBackgroundHTMLData = []
      $scope.edge = edge
      const initRecordingTimeline = async () => {
        serialNumber = $scope.edge.uri
        $scope.selectedInput.dataLoading = true
        $scope.selectedInput.date = new Date()
        updateCurrentDeviceSemanticVersion()
        applyRecordingTimelineChanges(true)
      }
      if ($scope.edge) {
        $timeout(() => {
          initRecordingTimeline()
        })
      } else {
        $scope.$emit('LOAD_DEVICE_DETAILS_REQUEST', { id: deviceId })
        const canceller = $scope.$on(
          'LOAD_DEVICE_DETAILS_SUCCESS',
          async (_, data) => {
            if (data.id === deviceId) {
              canceller()
              edge = edgeFactory.list.find(e => e.id === deviceId)
              $scope.edge = edge
              initRecordingTimeline()
            }
          }
        )
      }
      $scope.switchToFileView = () => {
        $state.go('home.common.recordings.list', { edge_id: deviceId })
      }
      $scope.getCameraNameByStreamId = (edge, streamId) =>
        window.getCameraNameByStreamId($filter('translate'), edge, streamId)
      let rpcRecordingAvailabilityCanceller = null
      const cancelRpcRecordingAvailability = () => {
        if (
          rpcRecordingAvailabilityCanceller &&
          rpcRecordingAvailabilityCanceller.promise.$$state.status === 0
        ) {
          rpcRecordingAvailabilityCanceller.resolve()
        }
      }
      let timelineRecordingsData = []
      let availableTimelineRecordingDatesMap = {}
      const timelineMonthRecordingsDataCache = {}
      const updateTimelineMonthData = async selectedDate => {
        const { uri: serialNumber } = edge
        timelineRecordingsData = []
        availableTimelineRecordingDatesMap = {}
        const dateText = moment(selectedDate).format('YYYY-MM-DD')
        const startTime = moment
          .utc(dateText)
          .startOf('month')
          .add(-$scope.selectedInput.timezoneOffset, 'minutes')
          .toISOString()
        const endTime = moment
          .utc(dateText)
          .endOf('month')
          .add(-$scope.selectedInput.timezoneOffset, 'minutes')
          .toISOString()
        const cacheLabel = `${deviceId}-${startTime}-${endTime}`
        if (
          timelineMonthRecordingsDataCache[cacheLabel] &&
          timelineMonthRecordingsDataCache[cacheLabel].length
        ) {
          timelineRecordingsData = [
            ...timelineMonthRecordingsDataCache[cacheLabel]
          ]
        } else {
          cancelRpcRecordingAvailability()
          rpcRecordingAvailabilityCanceller = $q.defer()
          const requestJson = {
            method: 'GET',
            url: `${EDGE_BASEURL}/rpc-record-availability/${serialNumber}?start=${startTime}&end=${endTime}`,

            timeout: rpcRecordingAvailabilityCanceller.promise
          }
          try {
            const response = await $http(requestJson)
            if (response.data.status.code === 0) {
              timelineRecordingsData = [...response.data.data]
              timelineMonthRecordingsDataCache[cacheLabel] = [
                ...response.data.data
              ]
            }
          } catch (error) {
            if (error.xhrStatus !== 'abort') {
              handleServerError(error)
            }
          }
        }
        timelineRecordingsData.forEach(({ intervals }) => {
          intervals.forEach(interval => {
            availableTimelineRecordingDatesMap[
              moment
                .utc(interval.start_time * 1000)
                .add($scope.selectedInput.timezoneOffset, 'minutes')
                .format('YYYY-MM-DD')
            ] = true
            availableTimelineRecordingDatesMap[
              moment
                .utc(interval.end_time * 1000)
                .add($scope.selectedInput.timezoneOffset, 'minutes')
                .format('YYYY-MM-DD')
            ] = true
          })
        })
        $scope.higlightDates = Object.keys(availableTimelineRecordingDatesMap)
      }
      const applyRecordingTimelineChanges = async refreshData => {
        const selectedDate = $scope.selectedInput.date
        const dateText = moment(selectedDate).format('YYYY-MM-DD')
        const date = moment.utc(dateText)
        if (refreshData) {
          $scope.selectedInput.dataLoading = true
          await updateTimelineMonthData(selectedDate)
          $scope.selectedInput.dataLoading = false
        }
        updateTimelineSlider(
          date.startOf('day').unix() - $scope.selectedInput.timezoneOffset * 60,
          date.endOf('day').unix() - $scope.selectedInput.timezoneOffset * 60
        )
        $scope.playerState.showPlayer = false
      }
      const updateTimelineSlider = (startTime, endTime) => {
        const cameraId = $scope.selectedInput.cameraId
        $scope.timelineBackgroundHTMLData = []
        const cameraRecordingsData = timelineRecordingsData.find(
          rd => rd.camera_id === cameraId
        )
        if (!cameraRecordingsData) return
        const { intervals } = cameraRecordingsData
        const currentIntervals = intervals.filter(interval => {
          const startTimeBetweenInterval =
            interval.start_time <= startTime && interval.end_time >= startTime
          const endTimeBetweenInterval =
            interval.start_time <= endTime && interval.end_time >= endTime
          const intervalExistsBetweenStartAndEnd =
            interval.start_time >= startTime && interval.end_time <= endTime
          return (
            startTimeBetweenInterval ||
            endTimeBetweenInterval ||
            intervalExistsBetweenStartAndEnd
          )
        })
        const adjustedCurrentIntervals = currentIntervals
          .filter(filterZeroRecordingsInterval)
          .map(interval => ({
            start_time:
              interval.start_time < startTime ? startTime : interval.start_time,
            end_time: interval.end_time > endTime ? endTime : interval.end_time
          }))
        let startingSliderValue = 0
        if (adjustedCurrentIntervals.length) {
          startingSliderValue = parseInt(
            (adjustedCurrentIntervals[0].start_time - startTime) / 60
          )
          $scope.timelineBackgroundHTMLData = adjustedCurrentIntervals.map(
            interval => {
              return {
                width:
                  ((interval.end_time - interval.start_time) * 100) /
                  (endTime - startTime),
                left:
                  ((interval.start_time - startTime) * 100) /
                  (endTime - startTime)
              }
            }
          )
        }
        $scope.sliderInputChanged(startingSliderValue)
      }
      const filterZeroRecordingsInterval = interval =>
        interval.end_time - interval.start_time > 0
      const getActualRecordingStartTime = (cameraId, selectedStartTime) => {
        const cameraRecordingsData = timelineRecordingsData.find(
          rd => rd.camera_id === cameraId
        )
        let hasRecording = false
        let recordingStartTime = selectedStartTime
        let timelineInterval
        if (cameraRecordingsData) {
          timelineInterval = cameraRecordingsData.intervals.find(
            interval =>
              (interval.start_time <= selectedStartTime ||
                interval.start_time - selectedStartTime < 60) &&
              interval.end_time >= selectedStartTime
          )
          if (timelineInterval) {
            hasRecording = true
            if (timelineInterval.start_time > selectedStartTime) {
              recordingStartTime = timelineInterval.start_time
            }
          }
        }
        return hasRecording && { recordingStartTime, timelineInterval }
      }
      const getRecordingAvailability = () => {
        const selectedDateText = moment($scope.selectedInput.date).format(
          'YYYY-MM-DD'
        )
        const date = moment.utc(selectedDateText)
        const cameraId = $scope.selectedInput.cameraId
        const startOfDay =
          date.startOf('day').unix() - $scope.selectedInput.timezoneOffset * 60
        const selectedStartTime =
          startOfDay + $scope.selectedInput.sliderValue * 60
        const { recordingStartTime } = getActualRecordingStartTime(
          cameraId,
          selectedStartTime
        )
        return {
          recordingStartTime,
          hasRecording: !!recordingStartTime
        }
      }
      $scope.closeTimelineVideo = () => {
        $scope.playerState.showPlayer = false
      }
      $scope.playerTimelineVideo = () => {
        const availaleRecording = getRecordingAvailability()
        if (!availaleRecording.hasRecording) return
        $scope.recordingData = {
          mediaToken: $localStorage.userMediaAccessToken,
          serialNumber,
          nearestLocation: {
            time: availaleRecording.recordingStartTime
          },
          streamId: $scope.selectedInput.cameraId,
          edge,
          recordingStreamQuality: $scope.selectedInput.recordingStreamQuality
        }
        const timeDetails = moment
          .utc(availaleRecording.recordingStartTime * 1000)
          .add($scope.selectedInput.timezoneOffset, 'minutes')
          .format('lll')
        $scope.playerState.streamDetails = `${$scope.getCameraNameByStreamId(
          edge,
          $scope.selectedInput.cameraId
        )} : ${timeDetails}`
        $scope.playerState.showPlayer = false
        $timeout(() => {
          $scope.playerState.showPlayer = true
        }, 500)
      }
      $scope.showTimelineDownload = ev => {
        const availaleRecording = getRecordingAvailability()
        if (!availaleRecording.hasRecording) return
        const recordingData = {
          mediaToken: $localStorage.userMediaAccessToken,
          edge,
          serialNumber,
          streamId: $scope.selectedInput.cameraId,
          recordingStartTime: availaleRecording.recordingStartTime,
          timezoneOffset: $scope.selectedInput.timezoneOffset,
          recordingStreamQuality: $scope.selectedInput.recordingStreamQuality
        }
        $mdDialog
          .show({
            locals: {
              dataFromCaller: {
                getActualRecordingStartTime,
                recordingData,
                edge: edge
              }
            },
            controller: 'RecordingTimelineDownloadController',
            templateUrl:
              './templates/recording-timeline-download.view.html?t=' +
              window.webpackHash,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          })
          .then(() => {})
          .catch(() => {})
      }
      $scope.monthChange = async date => {
        await updateTimelineMonthData(date)
      }
      $scope.dateChange = date => {
        $scope.selectedInput.date = date
        applyRecordingTimelineChanges()
      }
      $scope.cameraChange = () => {
        applyRecordingTimelineChanges()
      }
      $scope.timezoneChange = () => {
        applyRecordingTimelineChanges(true)
      }
      let trackSliderInputTimeout = null
      $scope.sliderInputChanged = sliderValue => {
        trackSliderInputTimeout && $timeout.cancel(trackSliderInputTimeout)
        $scope.playerState.hasRecording = false
        trackSliderInputTimeout = $timeout(() => {
          $scope.selectedInput.sliderValue = sliderValue
          $scope.selectedInput.currentSliderValue = sliderValue
          $scope.playerState.hasRecording = getRecordingAvailability().hasRecording
        }, 1000)
      }
      $scope.getTimeFromSliderValue = sliderValue => {
        return moment()
          .startOf('day')
          .add(sliderValue, 'minutes')
          .format('hh:mm A')
      }
      $scope.$on('$destroy', () => {
        cancelRpcRecordingAvailability()
      })
      const handleServerError = response => {
        $scope.$emit('handleServerError', response)
      }
    }
  ])
